import client from '../client';

export const _addSchoolAssignment = async (payload) => {
  return await client.post(`school/assignments`, payload, { credentials: 'omit' });
};
export const _updateSchoolAssignment = async (assignmentId, userId, payload) => {
  return await client.patch(`school/${userId}/assignments/${assignmentId}`, payload, { credentials: 'omit' });
};
